import Header from './AssociateHeaderPage';

export default Header;
